import {managePif} from "./PifInfos.module";

managePif();
